import axios from 'lib/utils/axios';

import bindWalletRequest from 'api/requests/wallet/bindWallet';
import getWalletListRequest from 'api/requests/wallet/getWalletList';
import changeWalletRequest from 'api/requests/wallet/changeWallet';
import confirmationWalletRequest from 'api/requests/wallet/confirmationWallet';

import logrocket from '@/services/logrocket';

const bindWallet = async (state, payload) => {
  try {
    const { data } = await bindWalletRequest(axios, payload);

    return data;
  } catch (error) {
    logrocket.logger(error);
    throw new Error;
  }
};

const fetchWalletList = async (state) => {
  try {
    const { data } = await getWalletListRequest(axios);

    state.commit('SET_WALLET_LIST', data);
  } catch (error) {
    logrocket.logger(error);
    throw new Error;
  }
};

const changeWallet = async (state, payload) => {
  try {
    const { data } = await changeWalletRequest(axios, payload.id);

    return data;
  } catch (error) {
    logrocket.logger(error);
    throw new Error;
  }
};

const confirmationWallet = async (state, payload) => {
  try {
    await confirmationWalletRequest(axios, payload);
  } catch (error) {
    logrocket.logger(error);
    throw new Error;
  }
};

export default {
  bindWallet,
  fetchWalletList,
  changeWallet,
  confirmationWallet,
};
